export default "__VITE_ASSET__segDECTv__"